type IconWidthAndHeight = "14px" | "16px" | "20px" | "24px" | "100%";

export type IconSize = "small" | "medium" | "large" | "xlarge" | "fill";

export const iconSizeMap: {
  [key in IconSize]: {
    width: IconWidthAndHeight;
    height: IconWidthAndHeight;
  };
} = {
  small: {
    width: "14px",
    height: "14px"
  },
  medium: {
    width: "16px",
    height: "16px"
  },
  large: {
    width: "20px",
    height: "20px"
  },
  xlarge: {
    width: "24px",
    height: "24px"
  },
  fill: {
    width: "100%",
    height: "100%"
  }
};
